export default {
  optionsComment: '',
  optionsList: null,
  optionsListOriginal: null,
  optionsErrors: {
    calculate: false,
    inBasket: false,
  },
  isDisabledDlypr: false,
}
